var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-inline-select"},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,class:[
      'dp-inline-select__option',
      {
        'dp-inline-select__option--active': _vm.value === option.value,
        'dp-inline-select__option--attached': _vm.attached,
      }
    ],on:{"click":function($event){return _vm.selectOption(option)}}},[(option.icon)?_c('dp-icon',{attrs:{"name":option.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(option.label))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }